import { CheckCircle2, Clock, XCircle, type LucideIcon } from 'lucide-react';

import { PHOTO_STATUS, type SubmissionPhotoStatus } from '@/components/submissions/useSubmissions';

/** Badge variants exposed by the shared `Badge` component. */
type BadgeVariant = 'default' | 'secondary' | 'destructive' | 'outline';

/** Presentation metadata for a review status — one source of truth. */
export interface SubmissionStatusMeta {
  label: string;
  badgeVariant: BadgeVariant;
  /** Text/icon tone class using semantic tokens. */
  toneClass: string;
  icon: LucideIcon;
}

/**
 * Maps each photo-review status to its label, badge variant, tone, and icon.
 * Approved uses the brand "pin green" (`text-secondary`); rejected uses
 * `destructive`; pending is a neutral amber.
 */
export const SUBMISSION_STATUS_META: Record<SubmissionPhotoStatus, SubmissionStatusMeta> = {
  [PHOTO_STATUS.pending]: {
    label: 'Pending',
    badgeVariant: 'outline',
    toneClass: 'text-amber-600',
    icon: Clock,
  },
  [PHOTO_STATUS.approved]: {
    label: 'Approved',
    badgeVariant: 'secondary',
    toneClass: 'text-secondary',
    icon: CheckCircle2,
  },
  [PHOTO_STATUS.rejected]: {
    label: 'Rejected',
    badgeVariant: 'destructive',
    toneClass: 'text-destructive',
    icon: XCircle,
  },
};

// Re-exported so existing submissions imports keep working; the
// implementation is the shared datetime helper.
export { formatRelativeTime } from '@/lib/datetime';
